import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import API from '../../services/api';

const SC = { live: '#00ff88', coming_soon: '#00C8FF', maintenance: '#ff6b6b' };
const SL = { live: '🟢 Live', coming_soon: '🟡 Soon', maintenance: '🔴 Down' };

export default function GamesPage() {
  const navigate = useNavigate();
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');
  const [search, setSearch] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    API.get('/games').then(({ data }) => setGames(Array.isArray(data) ? data : data.games || [])).catch(console.error).finally(() => setLoading(false));
  }, []);

  const featured = games.filter(g => g.featured);
  const filtered = games.filter(g => {
    const mf = filter === 'all' || g.status === filter;
    const ms = g.name.toLowerCase().includes(search.toLowerCase()) || g.genre.toLowerCase().includes(search.toLowerCase());
    return mf && ms;
  });

  return (
    <div style={{ minHeight: '100vh', background: '#080c14', fontFamily: "'Exo 2',sans-serif", color: '#e2e8f0', overflowX: 'hidden' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Rajdhani:wght@600;700&family=Exo+2:wght@400;600;700;900&display=swap');
        *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
        .gp-bg{position:fixed;inset:0;background-image:linear-gradient(rgba(0,200,255,.025) 1px,transparent 1px),linear-gradient(90deg,rgba(0,200,255,.025) 1px,transparent 1px);background-size:50px 50px;pointer-events:none;z-index:0}
        .gp-nav{position:sticky;top:0;background:rgba(8,12,20,.96);backdrop-filter:blur(12px);border-bottom:1px solid rgba(0,200,255,.08);z-index:100}
        .gp-nav-inner{max-width:1200px;margin:0 auto;padding:0 20px;height:62px;display:flex;align-items:center;gap:20px}
        .gp-logo{display:flex;align-items:center;gap:7px;text-decoration:none;flex-shrink:0}
        .gp-logo-text{font-family:'Rajdhani',sans-serif;font-size:19px;font-weight:700;color:#00C8FF;letter-spacing:5px}
        .gp-nav-links{display:flex;gap:20px;flex:1}
        .gp-nav-link{color:rgba(255,255,255,.45);text-decoration:none;font-size:13px;font-weight:600;letter-spacing:1px}
        .gp-nav-link:hover{color:#00C8FF}
        .gp-login-btn{background:#00C8FF;color:#080c14;padding:7px 15px;border-radius:8px;text-decoration:none;font-size:12px;font-weight:900;letter-spacing:1px;flex-shrink:0}
        .gp-hamburger{display:none;background:none;border:1px solid rgba(0,200,255,.25);color:#00C8FF;font-size:17px;cursor:pointer;padding:5px 9px;border-radius:7px;margin-left:auto}
        .gp-mobile-menu{display:none;position:fixed;top:62px;left:0;right:0;background:rgba(8,12,20,.98);backdrop-filter:blur(12px);border-bottom:1px solid rgba(0,200,255,.1);padding:14px 20px;flex-direction:column;gap:4px;z-index:99}
        .gp-mobile-menu.open{display:flex}
        .gp-mobile-link{color:rgba(255,255,255,.6);text-decoration:none;font-size:14px;font-weight:600;padding:11px 0;border-bottom:1px solid rgba(255,255,255,.05);display:block}
        .gp-inner{max-width:1200px;margin:0 auto;padding:40px 20px;position:relative;z-index:1}
        .gp-header{text-align:center;margin-bottom:40px}
        .gp-tag{color:rgba(0,200,255,.6);font-size:10px;font-weight:900;letter-spacing:4px;margin-bottom:8px}
        .gp-title{font-family:'Rajdhani',sans-serif;font-size:clamp(28px,5vw,52px);font-weight:700;color:#e2e8f0;margin-bottom:8px}
        .gp-sub{color:rgba(255,255,255,.3);font-size:14px}
        .gp-featured-label{color:rgba(0,200,255,.6);font-size:10px;font-weight:900;letter-spacing:3px;margin-bottom:14px}
        .gp-featured-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(280px,1fr));gap:16px;margin-bottom:44px}
        .gp-feat-card{border-radius:16px;overflow:hidden;position:relative;height:200px;border:1px solid rgba(0,180,255,.2)}
        .gp-feat-img{width:100%;height:100%;object-fit:cover}
        .gp-feat-ph{width:100%;height:100%;background:rgba(0,200,255,.04);display:flex;align-items:center;justify-content:center;font-size:52px}
        .gp-feat-overlay{position:absolute;bottom:0;left:0;right:0;padding:16px;background:linear-gradient(transparent,rgba(0,0,0,.88))}
        .gp-feat-name{font-size:18px;font-weight:700;color:#fff;margin-bottom:4px;font-family:'Rajdhani',sans-serif}
        .gp-feat-genre{font-size:11px;color:rgba(255,255,255,.45);margin-bottom:8px}
        .gp-feat-play{background:#00C8FF;border:none;border-radius:7px;padding:7px 16px;color:#080c14;font-size:11px;font-weight:900;cursor:pointer;letter-spacing:1px}
        .gp-controls{display:flex;gap:14px;margin-bottom:28px;flex-wrap:wrap;align-items:center}
        .gp-search{flex:1;min-width:180px;background:#0d1420;border:1px solid rgba(0,200,255,.12);border-radius:11px;padding:12px 16px;color:#fff;font-size:14px;font-family:'Exo 2',sans-serif;outline:none}
        .gp-filters{display:flex;gap:7px;flex-wrap:wrap}
        .gp-filter{padding:9px 14px;border-radius:9px;border:1px solid rgba(255,255,255,.08);background:transparent;color:rgba(255,255,255,.35);cursor:pointer;font-size:12px;font-family:'Exo 2',sans-serif;transition:all .2s}
        .gp-filter:hover{color:#00C8FF;border-color:rgba(0,200,255,.2)}
        .gp-filter.active{background:rgba(0,200,255,.08);color:#00C8FF;border-color:rgba(0,200,255,.3)}
        .gp-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(220px,1fr));gap:16px}
        .gp-card{background:#0d1420;border-radius:16px;border:1px solid rgba(0,200,255,.08);overflow:hidden;transition:all .25s}
        .gp-card:hover{transform:translateY(-5px);border-color:rgba(0,200,255,.3)}
        .gp-card-img-wrap{position:relative}
        .gp-card-img{width:100%;height:150px;object-fit:cover;display:block}
        .gp-card-ph{width:100%;height:110px;background:rgba(0,200,255,.04);display:flex;align-items:center;justify-content:center;font-size:40px}
        .gp-card-feat{position:absolute;top:9px;left:9px;background:rgba(0,180,255,.15);border:1px solid rgba(0,180,255,.4);color:#00C8FF;border-radius:5px;padding:2px 7px;font-size:9px;font-weight:700}
        .gp-card-stat{position:absolute;top:9px;right:9px;background:rgba(0,0,0,.6);border:1px solid;border-radius:5px;padding:2px 7px;font-size:9px;font-weight:700}
        .gp-card-body{padding:14px}
        .gp-card-top{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:6px;gap:5px}
        .gp-card-name{font-size:14px;font-weight:700;color:#e2e8f0;flex:1}
        .gp-genre{background:rgba(0,200,255,.1);border:1px solid rgba(0,200,255,.2);color:#1E6FFF;border-radius:5px;padding:2px 6px;font-size:9px;flex-shrink:0}
        .gp-card-desc{color:rgba(255,255,255,.3);font-size:11px;line-height:1.5;margin-bottom:9px}
        .gp-play-btn{width:100%;background:#00C8FF;border:none;border-radius:9px;padding:9px;color:#080c14;font-size:12px;font-weight:900;letter-spacing:1px;cursor:pointer;font-family:'Rajdhani',sans-serif;transition:background .2s}
        .gp-play-btn:hover{background:#00C8FF}
        .gp-loading,.gp-empty{text-align:center;color:rgba(255,255,255,.25);padding:70px;font-size:14px}
        .gp-footer{border-top:1px solid rgba(0,200,255,.06);padding:22px;text-align:center;position:relative;z-index:1}
        .gp-footer-text{color:rgba(255,255,255,.2);font-size:12px}
        .gp-footer-link{color:rgba(0,200,255,.5);text-decoration:none}
        @media(max-width:768px){
          .gp-nav-links,.gp-login-btn{display:none}
          .gp-hamburger{display:block}
          .gp-featured-grid{grid-template-columns:1fr 1fr}
          .gp-grid{grid-template-columns:1fr 1fr}
          .gp-inner{padding:32px 16px}
        }
        @media(max-width:480px){
          .gp-featured-grid{grid-template-columns:1fr}
          .gp-grid{grid-template-columns:1fr}
          .gp-controls{flex-direction:column;align-items:stretch}
          .gp-search{width:100%}
        }
      `}</style>
      <div className="gp-bg" />

      <nav className="gp-nav">
        <div className="gp-nav-inner">
          <Link to="/" className="gp-logo"><img src="/logo.jpg" alt="AIA74" style={{ height: "38px", width: "auto", objectFit: "contain" }} /></Link>
          <div className="gp-nav-links">
            <Link to="/" className="gp-nav-link">Home</Link>
            <Link to="/offers" className="gp-nav-link">Offers</Link>
            <Link to="/support" className="gp-nav-link">Support</Link>
          </div>
          <Link to="/login" className="gp-login-btn">→ LOGIN</Link>
          <button className="gp-hamburger" onClick={() => setMenuOpen(!menuOpen)}>☰</button>
        </div>
      </nav>
      <div className={`gp-mobile-menu${menuOpen ? ' open' : ''}`}>
        <Link to="/" className="gp-mobile-link" onClick={() => setMenuOpen(false)}>🏠 Home</Link>
        <Link to="/offers" className="gp-mobile-link" onClick={() => setMenuOpen(false)}>🎁 Offers</Link>
        <Link to="/support" className="gp-mobile-link" onClick={() => setMenuOpen(false)}>💬 Support</Link>
        <Link to="/login" className="gp-mobile-link" onClick={() => setMenuOpen(false)} style={{ color: '#00C8FF' }}>→ Login</Link>
      </div>

      <div className="gp-inner">
        <div className="gp-header">
          <div className="gp-tag">GAME CATALOGUE</div>
          <h1 className="gp-title">All Games</h1>
          <p className="gp-sub">Browse our complete collection of premium fantasy games</p>
        </div>

        {featured.length > 0 && (
          <div>
            <div className="gp-featured-label">⭐ FEATURED GAMES</div>
            <div className="gp-featured-grid">
              {featured.map(game => (
                <div key={game._id} className="gp-feat-card">
                  {game.imageUrl ? <img src={game.imageUrl} alt={game.name} className="gp-feat-img" /> : <div className="gp-feat-ph">🎮</div>}
                  <div className="gp-feat-overlay">
                    <h2 className="gp-feat-name">{game.name}</h2>
                    <p className="gp-feat-genre">{game.genre} · {game.platform}</p>
                    <button className="gp-feat-play" onClick={() => navigate('/login')}>▶ PLAY NOW</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="gp-controls">
          <input className="gp-search" placeholder="🔍  Search by name or genre..." value={search} onChange={e => setSearch(e.target.value)} />
          <div className="gp-filters">
            {['all', 'live', 'coming_soon', 'maintenance'].map(f => (
              <button key={f} className={`gp-filter${filter === f ? ' active' : ''}`} onClick={() => setFilter(f)}>
                {f === 'all' ? 'All' : SL[f]}
              </button>
            ))}
          </div>
        </div>

        {loading ? <div className="gp-loading">Loading games...</div>
          : filtered.length === 0 ? <div className="gp-empty">🎮 No games found. Try a different search!</div>
          : (
            <div className="gp-grid">
              {filtered.map(game => (
                <div key={game._id} className="gp-card">
                  <div className="gp-card-img-wrap">
                    {game.imageUrl ? <img src={game.imageUrl} alt={game.name} className="gp-card-img" /> : <div className="gp-card-ph">🎮</div>}
                    {game.featured && <span className="gp-card-feat">⭐ Featured</span>}
                    <span className="gp-card-stat" style={{ color: SC[game.status], borderColor: SC[game.status] }}>{SL[game.status]}</span>
                  </div>
                  <div className="gp-card-body">
                    <div className="gp-card-top">
                      <h3 className="gp-card-name">{game.name}</h3>
                      <span className="gp-genre">{game.genre}</span>
                    </div>
                    <p className="gp-card-desc">{game.description ? game.description.slice(0, 65) + '…' : 'No description available.'}</p>
                    <button className="gp-play-btn" onClick={() => navigate('/login')}>▶ PLAY NOW</button>
                  </div>
                </div>
              ))}
            </div>
          )}
      </div>

      <footer className="gp-footer">
        <p className="gp-footer-text">© 2025 AIA74 · <Link to="/privacy" className="gp-footer-link">Privacy Policy</Link></p>
      </footer>
    </div>
  );
}